module.exports = __webpack_public_path__ + "img/6.eb94065e.png";